"use client";

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  return (
    <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "40px" }}>
      <div style={{ maxWidth: 480, textAlign: "center" }}>
        <p style={{ fontFamily: "var(--font-mono)", fontSize: 9, letterSpacing: "0.18em", textTransform: "uppercase", color: "var(--ink-3)", marginBottom: 16 }}>
          Error
        </p>
        <h1 style={{ fontFamily: "var(--font-display)", fontWeight: 400, fontSize: "clamp(32px, 5vw, 52px)", letterSpacing: "-0.03em", lineHeight: 1, marginBottom: 20 }}>
          Something went wrong.
        </h1>
        <p style={{ fontSize: 14, color: "var(--ink-3)", marginBottom: 32, lineHeight: 1.5 }}>
          {error.message || "An unexpected error occurred."}
        </p>
        <button className="ws-btn" onClick={reset}>Try again</button>
      </div>
    </div>
  );
}
